import React from 'react';
import { Link } from 'react-router-dom';
import useScrollAnimation from '../hooks/useScrollAnimation';
import useSeo from '../hooks/useSeo';
import ImageSlider from '../components/ImageSlider';
import './HomePage.css';
// Import des images pour le slider et les icônes
import { 
  facade_a1, 
  facade_a2, 
  maison_a1, 
  maison_a2, 
  mur_a1, 
  mur_a2, 
  mur_b1, 
  mur_b2, 
  sol_a1, 
  sol_a2, 
  sol_b1, 
  sol_b2, 
  toiture_a1, 
  toiture_a2,
  iconPeinture, 
  iconToiture, 
  iconRavalement, 
  iconStar, 
  iconShield, 
  iconEuro, 
  iconClock 
} from '../images/imageImports';

const HomePage = () => {
  const [heroRef, heroVisible] = useScrollAnimation(0.1);
  const [servicesRef, servicesVisible] = useScrollAnimation(0.1);
  const [featuresRef, featuresVisible] = useScrollAnimation(0.1);
  const [ctaRef, ctaVisible] = useScrollAnimation(0.1);

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (!servicesSection) return 
    
    servicesSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
  };

  useSeo({
    title: 'Vie et couleurs · Couverture · Peinture · Ravalement · Couëron',
    description: "Artisan spécialisé en couverture, peinture et ravalement de façade à Couëron et région nantaise. Devis gratuit, savoir-faire local reconnu. Transformez vos projets avec nos services professionnels.",
    canonical: 'https://www.vie-et-couleurs.fr/'
  });

  // Configuration du slider d'images - dans l'ordre du dossier
  const sliderImages = [
        {
      src: toiture_a2,
      alt: "Rénovation de toiture - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%)'
      }
    },
    {
      src: toiture_a1,
      alt: "Travaux de couverture - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%)'
      }
    },
    {
      src: facade_a1,
      alt: "Ravalement de façade - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%)'
      }
    },
    {
      src: facade_a2,
      alt: "Peinture de façade - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%)'
      }
    },
    {
      src: maison_a1,
      alt: "Rénovation de maison - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%)'
      }
    },
    {
      src: maison_a2,
      alt: "Travaux de maison - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%)'
      }
    },
    {
      src: mur_a1,
      alt: "Peinture - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%)'
      }
    },
    {
      src: mur_a2,
      alt: "Peinture de mur - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%)'
      }
    },
    {
      src: mur_b1,
      alt: "Rénovation de mur - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%)'
      }
    },
    {
      src: mur_b2,
      alt: "Peinture murale - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%)'
      }
    },
    {
      src: sol_a1,
      alt: "Rénovation de sol - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%)'
      }
    },
    {
      src: sol_a2,
      alt: "Travaux de sol - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%)'
      }
    },
    {
      src: sol_b1,
      alt: "Rénovation de plancher - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%)'
      }
    },
    {
      src: sol_b2,
      alt: "Travaux de plancher - Vie et Couleurs",
      overlay: {
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%)'
      }
    },
  ];

  return (
    <div className="home-page">
      {/* H1 principal pour SEO - toujours visible */}
      <h1 className="seo-main-title">
        Votre Artisan de Confiance - Peinture, Couverture et Ravalement à Couëron
      </h1>
      
      {/* Hero Section avec Slider */}
      <section className="hero-slider">
        <ImageSlider 
          images={sliderImages} 
          autoPlay={true} 
          interval={4000} 
        />
        <div className={`hero-content scroll-animate ${heroVisible ? 'visible' : ''}`} ref={heroRef}>
          <h2 className="hero-title">
            Votre Artisan de Confiance
          </h2>
          <p className="hero-subtitle">
            Spécialisé en peinture, couverture et ravalement de façade, nous transformons vos projets en réalité avec savoir-faire et professionnalisme.
          </p>
          <div className="hero-buttons">
            <button onClick={scrollToServices} className="btn btn-primary">
              Découvrir nos services
            </button>
            <Link to="/contact" className="btn btn-secondary">
              Demander un devis
            </Link>
          </div>
        </div>
      </section>

      {/* Section Présentation */}
      <section className="presentation-section">
        <div className="container">
          <div className="presentation-content">
            <h2 className={`section-title scroll-animate ${servicesVisible ? 'visible' : ''}`}>
              Artisan BTP spécialisé à Couëron et en région nantaise
            </h2>
            <div className="presentation-text">
              <p>
                <strong>Vie et Couleurs</strong> est votre partenaire de confiance pour tous vos travaux de 
                <strong> peinture, couverture et ravalement de façade</strong> dans la région nantaise. 
                Fort de plusieurs années d'expérience, nous intervenons sur <strong>Couëron</strong>, Nantes, Saint-Herblain 
                et les communes environnantes pour transformer vos projets en réalité.
              </p>
              <p>
                Notre équipe maîtrise les techniques de rénovation et d'entretien. 
                Que ce soit pour des travaux ponctuels ou des projets plus importants, 
                nous nous efforçons de vous proposer un travail de qualité avec des matériaux adaptés.
              </p>
              <p>
                Spécialisés dans le <strong>traitement anti-mousse des toitures</strong>, la 
                peinture hydrofuge et le nettoyage haute pression, 
                nous adaptons nos méthodes à chaque type de bâtiment et à vos besoins spécifiques.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section id="services" className="services-preview">
        <div className="container">
          <h2 className={`section-title scroll-animate ${servicesVisible ? 'visible' : ''}`} ref={servicesRef}>Nos Services</h2>
          <div className={`services-grid scroll-animate ${servicesVisible ? 'visible' : ''}`}>
            <Link to="/couverture" className="service-card service-card-link">
              <div className="service-icon"><img src={iconToiture} alt="Couverture" style={{height:'48px', width:'48px'}} /></div>
              <h3>Couverture</h3>
              <p>
                <strong>Traitement anti-mousse</strong> et <strong>hydrofuge</strong> pour protéger votre toiture. 
                Reprise de faîtage, changement d'ardoise et réparation de tuiles. 
                Intervention rapide pour <strong>fuites d'eau</strong> et dégâts des eaux.
              </p>
              <span className="service-link">Découvrir →</span>
            </Link>
            <Link to="/peinture-interieure" className="service-card service-card-link">
              <div className="service-icon"><img src={iconPeinture} alt="Peinture" style={{height:'48px', width:'48px'}} /></div>
              <h3>Peinture Intérieure et Extérieure</h3>
              <p>
                <strong>Peinture murs et plafonds</strong>, boiseries et sols. 
                <strong> Finitions propres et durables</strong> avec des peintures de qualité professionnelle. 
                Préparation des supports et <strong>protection hydrofuge</strong>.
              </p>
              <span className="service-link">Découvrir →</span>
            </Link>
            <Link to="/ravalement" className="service-card service-card-link">
              <div className="service-icon"><img src={iconRavalement} alt="Ravalement de façade" style={{height:'48px', width:'48px'}} /></div>
              <h3>Ravalement de Façade</h3>
              <p>
                <strong>Nettoyage haute pression</strong> de façade et toiture. <strong>Peinture façade </strong>
                et peinture toiture avec produits hydrofuges et respirants. 
                <strong> Protection renforcée</strong> contre les intempéries.
              </p>
              <span className="service-link">Découvrir →</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us">
        <div className="container">
          <h2 className={`section-title scroll-animate ${featuresVisible ? 'visible' : ''}`} ref={featuresRef}>Pourquoi nous choisir ?</h2>
          <div className={`features-grid scroll-animate ${featuresVisible ? 'visible' : ''}`}>
            <div className="feature">
              <div className="feature-icon"><img src={iconStar} alt="Savoir-faire" style={{height:'32px', width:'32px'}} /></div>
              <h3>Savoir-faire Artisanal</h3>
              <p>Savoir-faire local reconnu</p>
            </div>
            <div className="feature">
              <div className="feature-icon"><img src={iconShield} alt="Protection renforcée" style={{height:'32px', width:'32px'}} /></div>
              <h3>Protection Renforcée</h3>
              <p>Procédés éprouvés et durables</p>
            </div>
            <div className="feature">
              <div className="feature-icon"><img src={iconEuro} alt="Devis Gratuit" style={{height:'32px', width:'32px'}} /></div>
              <h3>Devis Gratuit</h3>
              <p>Estimation personnalisée sans engagement</p>
            </div>
            <div className="feature">
              <div className="feature-icon"><img src={iconClock} alt="Respect des Délais" style={{height:'32px', width:'32px'}} /></div>
              <h3>Respect des Délais</h3>
              <p>Livraison dans les temps convenus</p>
            </div>
          </div>
        </div>
      </section>

      {/* Zone d'intervention */}
      <section className="zone-intervention">
        <div className="container">
          <h2 className={`section-title scroll-animate ${featuresVisible ? 'visible' : ''}`}>
            Notre Zone d'Intervention en Loire-Atlantique
          </h2>
          <div className="zone-content">
            <div className="zone-text">
              <p>
                <strong>Vie et Couleurs</strong> intervient dans toute la région nantaise 
                et les communes environnantes. Nous nous déplaçons rapidement pour tous vos travaux de 
                peinture, couverture et ravalement dans un rayon de 80 km autour de <strong>Couëron</strong>.
              </p>
              <p>
                Nos principales zones d'intervention incluent : <strong>Couëron</strong>, 
                Nantes (centre-ville et quartiers), Saint-Herblain, Rezé, 
                Bouguenais, Orvault, Carquefou, 
                Sautron, La Chapelle-sur-Erdre et bien d'autres communes 
                de la métropole nantaise.
              </p>
              <p>
                Que vous soyez particulier ou professionnel, nous adaptons 
                nos interventions à vos contraintes horaires et géographiques. <strong>Devis gratuit </strong> 
                et <strong>déplacement sans frais</strong> dans notre zone d'intervention.
              </p>
            </div>
            <div className="zone-features">
              <div className="zone-feature">
                <h4>Déplacement Gratuit</h4>
                <p>Dans un rayon de 80 km autour de Couëron</p>
              </div>
              <div className="zone-feature">
                <h4>Intervention Rapide</h4>
                <p>Urgences et travaux programmés</p>
              </div>
              <div className="zone-feature">
                <h4>Particuliers & Pros</h4>
                <p>Maisons individuelles et bâtiments commerciaux</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="devis" className="cta-section">
        <div className="container">
          <div className={`cta-content scroll-animate ${ctaVisible ? 'visible' : ''}`} ref={ctaRef}>
            <h2>Devis Gratuit pour vos Travaux</h2>
            <p>Contactez-nous dès aujourd'hui pour un devis personnalisé et gratuit.</p>
            <Link to="/contact" className="btn btn-primary btn-large">
              Obtenir un devis gratuit
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;

